import { baseStore } from '@ambita/ambita-components-core';
import * as cadastreReportConstants from '../constants/cadastreReport';
import * as statesConstants from '../constants/componentStates';
import { TransformedCadastreLookup } from '../typings/CadastreReport';

const { actions: cadastreReportActions, events: cadastreReportEvents } = cadastreReportConstants;

export interface CadastreReportState {
  data?: TransformedCadastreLookup;
  error?: Object;
  tagStatus?: Number;
}

export interface CadastreReportAction extends baseStore.StoreAction {
  data?: TransformedCadastreLookup;
  error?: Object;
}

export const stateReducer = (state: CadastreReportState, action: CadastreReportAction): CadastreReportState => {
  switch (action.actionType) {
    case cadastreReportActions.CADASTRE_LOOKUP_LOADING:
      return {
        ...state,
        tagStatus: statesConstants.LOADING
      };
    case cadastreReportActions.STORE_CADASTRE_LOOKUP:
      return {
        ...state,
        data: action.data,
        error: null,
        tagStatus: statesConstants.DONE_SUCCESS
      };
    case cadastreReportActions.STORE_CADASTRE_LOOKUP_ERROR:
      return {
        ...state,
        data: null,
        error: action.error,
        tagStatus: statesConstants.DONE_FAILED
      };
    default:
      return state;
  }
};

export const eventCollector = (_: CadastreReportState, action: CadastreReportAction): baseStore.StoreEvent => {
  switch (action.actionType) {
    case cadastreReportActions.CADASTRE_LOOKUP_LOADING:
      return {
        name: cadastreReportEvents.CADASTRE_LOOKUP_LOADING
      };
    case cadastreReportActions.STORE_CADASTRE_LOOKUP:
    case cadastreReportActions.STORE_CADASTRE_LOOKUP_ERROR:
      return {
        name: cadastreReportEvents.CADASTRE_LOOKUP_LOADED
      };
    default:
      return null;
  }
};

const initialState: CadastreReportState = {
  data: null,
  error: null,
  tagStatus: statesConstants.INITIAL
};

class CadastreReport extends baseStore.Store<CadastreReportState> {
  isCadastreReportFinishedLoading(): boolean {
    return this.getState().tagStatus !== statesConstants.LOADING;
  }
}

export default new CadastreReport(stateReducer, eventCollector, initialState);
